(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ceremony-place"] && !Shopify.designMode) return;
  try {
    
function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
$(document).ready(function() { 
	var tab = getParam("tab") || 1;

  $("#prefecture").val(tab);
  $("#tabs .tab" + tab).addClass("active");

	$(".tab").hide();
	$("#tab"+tab).show();

  var _prefs = {};
  _prefs[1] = '1:北海道,2:青森県,3:岩手県,4:宮城県,5:秋田県,6:山形県,7:福島県'.split(",");
  _prefs[2] = '8:茨城県,9:栃木県,10:群馬県,11:埼玉県,12:千葉県,13:東京都,14:神奈川県'.split(",");
  _prefs[3] = '15:新潟県,16:富山県,17:石川県,18:福井県,19:山梨県,20:長野県'.split(",");
  _prefs[4] = '21:岐阜県,22:静岡県,23:愛知県'.split(",");
  _prefs[5] = '24:三重県,25:滋賀県,26:京都府,27:大阪府,28:兵庫県,29:奈良県,30:和歌山県'.split(",");
  _prefs[6] = '31:鳥取県,32:島根県,33:岡山県,34:広島県,35:山口県,36:徳島県,37:香川県,38:愛媛県,39:高知県'.split(",");
  _prefs[7] = '40:福岡県,41:佐賀県,42:長崎県,43:熊本県,44:大分県,45:宮崎県,46:鹿児島県,47:沖縄県'.split(",");

  var setPlace = function(tab) {
    if (!tab) {
      tab = 1;
    }
    
    var api = Kanaco.api_base+"/Shopify_Customer_Ceremony?tab=" + tab;
  	Kanaco.ajax({
  	  type: "GET",
  	  url: api,
  	  data: {},
      dataType: "json"
  	}).done(function(res) {

      if (res.data) {
        for (var _tab=1; _tab<=7; _tab++) {
          var html = "";
          html += '<div id="tab' + _tab + '" class="tab clearfix">';
          for (var i in _prefs[_tab]) {
            var _ar = _prefs[_tab][i].split(":");

            html += '<h3 id="anc' + _ar[0] + '" name="anc' + _ar[0] + '"><span>' + _ar[1] + '</span></h3>';
            html += '<ul class="clearfix">';

            if (res.data[_ar[1]]) {
              for (var j in res.data[_ar[1]]){
                html += '<li>' + res.data[_ar[1]][j]["ceremony_name"] + '</li>';
              }
            } else {
              html += '&nbsp;';
            }

            html += '</ul>';
          }

          html += '</div>';

          if ($("#tab" + _tab).length) {
            $("#tab" + _tab).html($(html).html());
            
          } else {
            $(".tabBox").append(html);
          }
          $("#tab" + _tab).hide();
          if (tab == _tab) {
            $("#tab" + _tab).show();
          }
        }

        if (location.hash) {
          //setTimeout(function(){
            var top = $(location.hash).position().top;
            if ($("body").hasClass("spLayout")) {
              top -= $("sticky-header:not(#headerAreaSectionS)").outerHeight(true) + 20;
            } else {
              top -= $("#headerAreaSectionS").outerHeight(true);
            }
            $(window).scrollTop(top);
            //$('html,body').animate({ scrollTop: top }, 'swing');


          //}, 500);
        }
      }
    });
  }
  setPlace(getParam("tab"));

  //スマホ用
  $("#prefecture").on("change", function(){
    if ($(this).val() > 0) {
      var tab = $(this).find("option:selected").data("tab");
      var replace = "place?tab=" + tab + "#anc"+$(this).val();
      history.replaceState('', '', replace);
      setPlace(tab);
    }
  });

  //都道府県選択
  $(document).on("click", "a.selectPrefecture", function() {
    var replace = "place?tab=" + $(this).data("tab") + $(this).data("anc");
    history.replaceState('', '', replace);
    setPlace($(this).data("tab"));
    return false;
  });
  //地方タブ選択
  $(document).on("click", "a.selectTab", function() {
    $(".selectTab").removeClass("active");
    $(this).addClass("active");
    var replace = "place?tab=" + $(this).data("tab");
    history.replaceState('', '', replace);
    setPlace($(this).data("tab"));
    return false;
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() { 

  var api = Kanaco.api_base+"/Qa";

  //カテゴリの一覧を取得
	//Kanaco.ajax({
  	Kanaco.api({
	  type: "GET",
	  url: api + "?mode=cat",
	  data: {},
    dataType: "json"
	}).done(function(res) {

    if (res.data.categories) {
      var html = "";
      html += '<select id="cat_code" name="cat_code">';
      html += '  <option value="" selected="selected">-- 選択してください --</option>';
      for (var i in res.data.categories) {
        var category = res.data.categories[i];
        html += '<option value="' + category["id"] + '" >' + category["name"] + '</option>';
      }
      html += '</select>';

      $(".searchCatSelect").html(html);

      $("#cat_code").on("change", function(){
        getQA();
      });

    }
  });

  $(".bsmBtnSearch").on("click", function() {
    getQA();
  });

  var getQA = function() {
    var cid = "";
    if ($("#cat_code").length) {
      cid = $("#cat_code").val();
    }
    var search_text = "";
    if ($("#fword").length) {
      search_text = $("#fword").val();
    }
  	//Kanaco.ajax({
  	Kanaco.api({
  	  type: "GET",
  	  url: api + "?cid=" + cid + "&search_text=" + search_text,
  	  data: {},
      dataType: "json"
      }).done(function(res) {
  console.log(JSON.stringify(res.data.groups));  // ← 一時追加
        if (res.data.groups) {
          var qaHtml = "";
          var navHtml = '<ul class="groupItemBox">';

          for (var i in res.data.groups) {
            var group = res.data.groups[i];
            for (var ii in group.categories) {
              var category = group.categories[ii];
              var catId = "cat-" + category["cid"];

              navHtml += '<li><a href="#' + catId + '">' + category["name"] + '</a></li>';

              qaHtml += '<div class="qaCatBox clearfix" id="' + catId + '">';
              qaHtml += '  <div class="qaCat">';
              qaHtml += '    <h3>' + category["name"] + '</h3>';
              qaHtml += '  </div>';
              qaHtml += '  <div class="qaBoxOuter">';

              for (var iii in category.entries) {
                var entry = category.entries[iii];

                var answer = entry["answer"];
                answer = answer.replace(/(src=")\/global-data(\/(.+?)")/g, '$1' + 'https://' + Kanaco.domain + '/images/shopify/global-data' + '$2');
                answer = answer.replace(/(src=")\/usr-data(\/(.+?)")/g, '$1' + 'https://' + Kanaco.domain + '/images/shopify' + '$2');

                qaHtml += '  <div class="qaBox">';
                qaHtml += '    <div class="qBox">';
                qaHtml += '      <div class="qArea clearfix">';
                qaHtml += '        <img class="qImg" src="https://' + Kanaco.domain + '/images/shopify/global-image/units/img/354-1-20170314184324_b58c7bb3c0fe9b.png" border="0">';
                qaHtml += '        <div class="qAnc">';
                qaHtml += '          <div class="qTxt">' + entry["question"] + '</div>';
                qaHtml += '          <span class="icoOpen">+</span><span class="icoClose" style="display: none;">-</span>';
                qaHtml += '        </div>';
                qaHtml += '      </div>';
                qaHtml += '    </div>';
                qaHtml += '    <div class="answerArea" style="display: none;">';
                qaHtml += '      <div class="answerBox clearfix">';
                qaHtml += '        <img src="https://' + Kanaco.domain + '/images/shopify/global-image/units/img/354-1-20170314184324_b58c7bb3c10074.png" border="0">';
                qaHtml += '        <div class="answer">';
                qaHtml += answer;

                if (entry.image) {
                  qaHtml += '        <div class="imageOuter"><img src="' + entry.image + '"></div>';
                }

                if (entry.links) {
                  qaHtml += '        <div class="rlinkbxOuter">';
                  for (var iiii in entry.links) {
                    var link = entry.links[iiii];
                    qaHtml += '        <span class="rlinkbx">';
                    qaHtml += '          <a style="background-image: url(https://' + Kanaco.domain + '/images/shopify/template/after-bouquet-2nd01-202308_77/common-img/ico_arrow.gif);" href="' + link.url + '" target="_blank">' + link.title + '</a>';
                    qaHtml += '        </span>';
                  }
                  qaHtml += '        </div>';
                }

                qaHtml += '        </div>';
                qaHtml += '      </div>';
                qaHtml += '    </div>';
                qaHtml += '  </div>';
              }

              qaHtml += '  </div>';
              qaHtml += '</div>';
            }
          }

          navHtml += '</ul>';
          navHtml = Shopify.rewriteLink(navHtml);
          qaHtml  = Shopify.rewriteLink(qaHtml);

          $("#catNavArea").html(navHtml);
          $("#qaArea").html(qaHtml);

        } else {
          $("#catNavArea").html("");
          $("#qaArea").html('<p style="padding: 50px; border: 10px solid #F4F4F4; color: #999; text-align: center; font-size: 1.2em;">登録されている情報はありません。</p>');
        }
      });
  }
  getQA();

  $(document).on("click", ".qAnc", function(){
    $ans = $(this).parents(".qaBox:first").find(".answerArea:first");
    $ans.slideToggle(600);
    $(this).find('.icoOpen, .icoClose').toggle();
  });

  //エンター制御
  $("#fword").on('keypress', function(ev) {
    if ((ev.which && ev.which === 13) || (ev.keyCode && ev.keyCode === 13)) {
      getQA();
    }
    return true;
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // FV が存在するページでは、DOMContentLoaded 後に theme.liquid の JS が
      // .index-hero-slideshow-section クラスを付与する。load イベントで再取得して
      // FV 高さベースの閾値を確定させる。resize 時も再計算する。
      window.addEventListener('load', this.updateFvBounds.bind(this));
      window.addEventListener('resize', this.updateFvBounds.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      this.brandHeader = this.section ? this.section.querySelector('#headerAreaOuter') : null;
      const target = (this.brandHeader && this.brandHeader.offsetHeight > 0) ? this.brandHeader : this;
      this.headerBounds = target.getBoundingClientRect();
      this.updateFvBounds();
    }

    // FV スライドショーセクションの高さからスクロール閾値を計算する。
    // FV の中間点 (fvMidScrollTop): 透過 → 白背景への切り替えポイント。
    // FV の下端 (fvBottomScrollTop): hide/reveal を許可するポイント。
    // DOMContentLoaded 時点では .index-hero-slideshow-section が未付与の場合があるため
    // load イベントでも再呼び出しされる（connectedCallback 参照）。
    updateFvBounds() {
      const fvSection = document.querySelector('.index-hero-slideshow-section');
      if (fvSection && fvSection.offsetHeight > 0) {
        const fvH = fvSection.offsetHeight;
        this.fvMidScrollTop = fvH / 2;
        this.fvBottomScrollTop = fvH;
      } else {
        this.fvMidScrollTop = null;
        this.fvBottomScrollTop = null;
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const fvMid = this.fvMidScrollTop;    // FV 中間点（透過 → 白背景の切り替え）
      const fvBot = this.fvBottomScrollTop; // FV 下端（hide/reveal を開放する点）

      if (scrollTop <= this.headerBounds.top) {
        // Zone 0: ページ最上部 → 全クラスリセット（ブランドヘッダーが見える位置）
        this.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      } else if (fvMid != null && scrollTop < fvMid) {
        // Zone 1: FV 前半 → スティッキーだが背景は透過（FV画像を透かす）
        this.classList.add('shopify-section-header-sticky');
        this.classList.remove('shopify-section-header-hidden', 'scrolled-past-header', 'animate');
      } else if (fvMid != null && scrollTop <= fvBot) {
        // Zone 2: FV 後半 → 白背景の追従ヘッダーに切り替え（hide はしない）
        this.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
        this.classList.remove('shopify-section-header-hidden', 'animate');
        this.preventReveal = false;
      } else {
        // Zone 3: FV より下（または FV なし）→ 従来の hide / reveal ロジック
        // FV がある場合は fvBot を、ない場合は headerBounds.bottom を閾値とする
        const hideThreshold = fvBot != null ? fvBot : this.headerBounds.bottom;
        if (scrollTop > this.currentScrollTop && scrollTop > hideThreshold) {
          this.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > hideThreshold) {
          this.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.add('shopify-section-header-sticky', 'animate');
      this.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-stamp-about"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  //var $section = $(".messageBox").parents("section:first");
  //$(".messageBox").appendTo($("media-gallery")).show();
  //$section.hide();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["production-case"] && !Shopify.designMode) return;
  try {
    
var header_footer_disable = false;
if (location.href.match(/\/pages\/news(\/|\?|$)/)) {
  var getUrlParam = function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
  var tag = getUrlParam("tag");
  if (tag) {
    switch (tag) {
      case "押し花":
      case "ドライフラワー":
      case "制作工程":
      case "赤バラレイアウト":
      case "花束":
      case "リバティ":
        break;
      default:
        header_footer_disable = true;
    }
  }
  if (header_footer_disable) {
    var _style = '';
    _style += '<style>';
    _style += '.announcement-bar-section { display: none; }';
    _style += '.section-header { display: none !important; }';
    _style += '.shopify-section-group-footer-group { display: none; }'; 
    _style += '</style>';
    document.querySelector("head").insertAdjacentHTML("beforeend", _style);
  }
}
$(document).ready(function() {

  /* SP(768px未満)では検索プレースホルダーを短縮版に切り替える */
  (function() {
    var $input = $("#searchText");
    function updatePlaceholder() {
      var isSp = window.innerWidth < 768;
      $input.attr("placeholder", isSp ? $input.data("placeholder-sp") : $input.data("placeholder-pc"));
    }
    updatePlaceholder();
    $(window).on("resize", updatePlaceholder);
  })();

  //スマホの絞り込み調整
  //$("menu-drawer").on("click", function(){
  //  $(".mobile-facets__main").addClass("submenu-open");
  //  $("#Details-Mobile-1-template--19114838196506__main").addClass("menu-opening").attr("open", "");
  //  $("#Details-Mobile-1-template--19114838196506__main > .mobile-facets__summary").attr("aria-expanded", "true");
  //});

  var $section = $(".caseArea").parents(".shopify-section:first");
  var my_section_id = $section.attr("id").replace("shopify-section-", "");
  var detailPageBaseUrl = $section.find("[data-production-case-detail-url]").first().attr("data-production-case-detail-url");
  if (!detailPageBaseUrl) {
    detailPageBaseUrl = window.location.protocol + "//" + window.location.host + "/pages/gallery";
  }
  var slickSpBreakpoint = parseInt($section.find("[data-production-case-slick-sp]").attr("data-production-case-slick-sp"), 10);
  if (!slickSpBreakpoint || slickSpBreakpoint < 1) {
    slickSpBreakpoint = 989;
  }

  var _no = 0;
  /** 新着グリッドは最大件数まで先読み（スクロールで次ページを取らない） */
  var galleryLoadedCount = 0;
  var GALLERY_MAX_ITEMS = 1500;

  var getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  /* `?id=` 付きで来ても自動リダイレクトはしない（main の挙動に合わせる）。
     target_id は後段の初期表示分岐（一覧 update を呼ぶか）で参照する */
  var target_id = getQueryParam("id");

  //------------------------------------
  // 人気スライダー用カード HTML（Before & After も同一マークアップ）
  // 画像＋テキストを 1 カード（角丸・シャドウは CSS）。ホバーオーバーレイは使わない。
  //------------------------------------
  var escapeHtml = function(s) {
    if (s === null || s === undefined) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  };
  var buildPopularItemHtml = function(item, itemNo) {
    var thumb = item.image_thumb_url || '';
    var titleText = escapeHtml(item.dpdc_name || '');
    var thumbStyle = '';
    if (thumb) {
      thumbStyle = ' style="background-image: url(\'' + String(thumb).replace(/\\/g, '\\\\').replace(/'/g, '\\\'') + '\');"';
    }

    /*
      クリック時は新着グリッドと同じく /pages/gallery?id=XXXX へ直接遷移して詳細表示する。
      従来の caseItem クラス + モーダル（extMdlShowCaseDetail）方式は廃止。
      モーダル用の data-* はもう不要なため、識別に必要な data-id / data-no のみ残す。
    */
    var detailHref = detailPageBaseUrl + '?id=' + encodeURIComponent(item.dpdc_id);

    var item_html = "";
    item_html += '<div class="case" no="'+itemNo+'" data-id="'+item.dpdc_id+'">';
    item_html += '  <a href="' + detailHref + '" class="production-case-card__link js-fadeUp is-inview" data-id="'+item.dpdc_id+'" data-no="'+itemNo+'">';
    item_html += '    <span class="production-case-card">';
    item_html += '      <span class="production-case-card__media"'+thumbStyle+'></span>';
    item_html += '      <span class="production-case-card__body">';
    item_html += '        <span class="production-case-card__title">'+titleText+'</span>';
    item_html += '      </span>';
    item_html += '    </span>';
    item_html += '  </a>';
    item_html += '</div>';
    return item_html;
  };

  //------------------------------------
  // 人気の制作事例取得（Before & After は当面同一 API・同一データ）
  //------------------------------------
//------------------------------------
  // Before & After カードHTML生成
  //------------------------------------
    var buildBeforeAfterItemHtml = function(item, itemNo) {
    var afterThumb  = item.image_thumb_url  || item.image_url  || '';
    var beforeThumb = item.image_b_thumb_url || item.image_b_url || '';
    var titleText   = escapeHtml(item.dpdc_name || '');
    var detailHref  = detailPageBaseUrl + '?id=' + encodeURIComponent(item.dpdc_id) + '&source=beforeafter';

    function thumbStyle(url) {
      if (!url) return '';
      return ' style="background-image: url(\'' + String(url).replace(/\\/g, '\\\\').replace(/'/g, "\\'") + '\');"';
    }

    var html = '';
    html += '<div class="case before-after-case" no="' + itemNo + '" data-id="' + item.dpdc_id + '">';
    html += '  <a href="' + detailHref + '" class="production-case-card__link js-fadeUp is-inview" data-id="' + item.dpdc_id + '" data-no="' + itemNo + '">';
    html += '    <div class="production-case-card before-after-card">';
    html += '      <div class="before-after-card__images">';

    // Before画像（image_b_url がある場合のみ表示）
    if (beforeThumb) {
      html += '        <div class="before-after-card__item">';
      html += '          <div class="before-after-card__media before-after-card__media--before"' + thumbStyle(beforeThumb) + '></div>';
      html += '          <div class="before-after-card__label">Before</div>';
      html += '        </div>';
    }

    html += '      </div>';
    html += '      <div class="production-case-card__body">';
    html += '        <div class="production-case-card__title">' + titleText + '</div>';
    html += '      </div>';
    html += '    </div>';
    html += '  </a>';
    html += '</div>';
    return html;
  };

//------------------------------------
  // Before & After 取得（新API）
  // =======202607追加====== page=1,2,3… を「取得件数0」になるまで連続取得して全件表示する
  //------------------------------------
  var _baItems = [];                  // 取得済みアイテム（ページをまたいで蓄積）
  var _baSeenIds = {};                // 重複ガード（API が page を無視した場合の無限ループ防止）
  var BEFORE_AFTER_MAX_PAGE = 100;    // 安全弁

  var renderBeforeAfter = function() {
    if (!_baItems.length) return;
    var $beforeAfterInner = $('#shopify-section-' + my_section_id + ' #caseBeforeAfterAreaWrapper .production-case-carousel');
    if (!$beforeAfterInner.length) return;

    var html = '';
    for (var i = 0; i < _baItems.length; i++) {
      html += buildBeforeAfterItemHtml(_baItems[i], i + 1);
    }

    $('#caseBeforeAfterAreaWrapper').show();
    if ($beforeAfterInner.hasClass('slick-initialized')) {
      $beforeAfterInner.slick('unslick');
    }
    $beforeAfterInner.html(html);
    setUpProductionCaseSliders();
  };

  var getBeforeAfter = function(page) {
    if (typeof page === 'undefined') page = 1;
    var api = 'https://dx.kannax.com/api/Production_Case?mode=beforeAndAfter&page=' + page;
    $.ajax({
      type: 'GET',
      url: api,
      data: {},
      dataType: 'json'
    }).done(function(res) {
      var items = (res.data && res.data.items) ? res.data.items : [];
      var added = 0;

      for (var i = 0; i < items.length; i++) {
        var key = String(items[i].dpdc_id);
        if (_baSeenIds[key]) continue;   // 同一 ID は追加しない
        _baSeenIds[key] = 1;
        _baItems.push(items[i]);
        added++;
      }

      // 1ページ目は先に描画して初期表示を早める
      if (page === 1) renderBeforeAfter();

      // 取得件数0／新規0件／安全弁到達 で終了、それ以外は次ページへ
      if (items.length && added && page < BEFORE_AFTER_MAX_PAGE) {
        getBeforeAfter(page + 1);
      } else if (page > 1) {
        renderBeforeAfter();             // 全件そろった時点でまとめて再描画
      }
    }).fail(function() {
      if (page > 1) renderBeforeAfter();
    });
  };

  //------------------------------------
  // 人気の制作事例取得
  //------------------------------------
  var getPopular = function() {
    var section_id = my_section_id;
    var api = Kanaco.api_base+"/Production_Case?mode=popular";
    $.ajax({
      type: "GET",
      url: api,
      data: {},
      dataType: "json"
    }).done(function(res) {
      _no = 0;
      if (res.data && res.data.items && res.data.items.length) {
        var $popularInner = $("#shopify-section-" + section_id + " #casePopularAreaWrapper .production-case-carousel");
        $("#casePopularAreaWrapper").show();
        for (var i in res.data.items){
          var item = res.data.items[i];
          _no++;
          var item_html = buildPopularItemHtml(item, _no);
          $popularInner.append(item_html);
        }
        setUpProductionCaseSliders();
      }
    });
  }
  getPopular();
  getBeforeAfter();

  //パラメータにTagが指定された場合
  var stag = getQueryParam("tag");

  //------------------------------------
  // タグ取得
  //------------------------------------
  var checked_tags = [];
  //$.ajax({
  Kanaco.api({
    type: "GET",
    url: Kanaco.api_base+"/Production_Case?mode=grouptag&stag=" + stag,
    data: {},
    dataType: "json"
  }).done(function(res) {

    if (res.data && res.data.groups) {
      var checked = '';
      var tag_html = "";
      var mtag_html = "";

      /* デザイン上はドロップダウン 5 件。API が返すグループは先頭 5 のみ表示 */
      var MAX_GALLERY_FILTER_GROUPS = 5;
      var groupsSlice = Array.isArray(res.data.groups)
        ? res.data.groups.slice(0, MAX_GALLERY_FILTER_GROUPS)
        : [];

      






      tag_html += '<div class="tag-group-area-wrapper">';
      var dropdown_html = '<div class="tag-group-dropdowns">';
      for (var gi = 0; gi < groupsSlice.length; gi++) {
        var group = groupsSlice[gi];
        var group_name = (group.dptg_name ? group.dptg_name : 'その他');
        tag_html += '<div class="tag-group-area" data-group-index="' + gi + '">';
        tag_html += '  <div class="tag-group-area-inner">';
        tag_html += '    <div class="tag-group-name">';
        tag_html += '      <span class="name">' + group_name + '</span>';
        tag_html += '      <span class="state">';
        tag_html += '        <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">';
        tag_html += '          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">';
        tag_html += '          </path>';
        tag_html += '        </svg>';
        tag_html += '      </span>';
        tag_html += '    </div>';
        tag_html += '  </div>';
        tag_html += '</div>';

        // ドロップダウンはwrapperの外に生成
        dropdown_html += '<div class="tag-group-item-area" data-group-index="' + gi + '">';
        dropdown_html += '  <div class="tag-group-item-area-inner">';
        for (var j in group.subgroups){
          var subgroup = group.subgroups[j];
          if (subgroup.name != "-") {
            dropdown_html += '    <div class="tag-subgroup-name">';
            dropdown_html += '      <span class="name">' + subgroup.name + '</span>';
            dropdown_html += '    </div>';
          }
          var _class = "";
          if (5 >= subgroup.tags.length) {
            _class = " onerow";
          }
          dropdown_html += '      <div class="tag-item-area' + _class + '">';
          for (var k in subgroup.tags){
            var tag = subgroup.tags[k];
            var stagIds = stag ? stag.split(',') : [];
            if (stagIds.length && (stagIds.indexOf(String(tag.dpct_id)) !== -1 || stagIds.indexOf(tag.dpct_name) !== -1)) {
              checked = 'checked';
            } else {
              checked = '';
            }
            dropdown_html += '      <div class="tag-item selectTag">';
            dropdown_html += '        <label for="tag' + tag.dpct_id + '" class="facet-checkbox">';
            dropdown_html += '          <input type="checkbox" class="case-tag" name="filter.v.tag" data-group="' + group_name + '" data-tag="' + tag.dpct_name + '" data-id="' + tag.dpct_id + '" id="tag' + tag.dpct_id + '" value="' + tag.dpct_id + '" ' + checked + '>';
            dropdown_html += '          <svg width="1.6rem" height="1.6rem" viewBox="0 0 16 16">';
            dropdown_html += '            <rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect>';
            dropdown_html += '          </svg>';
            dropdown_html += '          <svg class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">';
            dropdown_html += '            <path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path>';
            dropdown_html += '          </svg>';
            dropdown_html += '          <span class="tag-name">' + tag.dpct_name + '</span>';
            dropdown_html += '        </label>';
            dropdown_html += '      </div>';
          }
          dropdown_html += '      </div>';
        }
        dropdown_html += '  </div>';
        dropdown_html += '</div>';
      }
      tag_html += '</div>';
      dropdown_html += '</div>';
      $("#caseTagGroup").append(tag_html + dropdown_html);

      // stagがある場合はchecked_tagsとselectTagAreaを復元
      if (stag) {
        var stagIds = stag.split(',');
        $(".selectTag input[type=checkbox]").each(function() {
          if (stagIds.indexOf(String($(this).data('id'))) !== -1) {
            checked_tags.push({
              id: $(this).data('id'),
              group: $(this).data('group'),
              tag: $(this).data('tag')
            });
          }
        });
        if (checked_tags.length) setSelectTagArea();
      }











      if (stag) {
        update(1, true);
      }
    }
  });
  
  // list_hrefの初期値：idを除いてtagは保持する
  var _initParams = new URLSearchParams(location.search);
  var _initTag = _initParams.get('tag');
  var list_href = location.protocol + '//' + location.host + location.pathname + (_initTag ? '?tag=' + encodeURIComponent(_initTag) : '');
  var resetListHref = function() {
    target_id = null;
    var basePath;
    if (location.pathname.match("/news/")) {
      basePath = location.protocol + '//' + location.host + '/pages/news';
    } else {
      basePath = location.protocol + '//' + location.host + '/pages/gallery';
    }
    var tagItems = [];
    $('.selectTag input[type=checkbox]:checked').each(function() {
      tagItems.push($(this).val());
    });
    list_href = basePath + (tagItems.length ? '?tag=' + encodeURIComponent(tagItems.join(',')) : '');
    if (location.href != list_href) {
      history.replaceState('showcase', null, list_href);
    }
  }
  

  var initArea = function() {
    $("#shopify-section-" + my_section_id + " .caseArea ul").html("");
  }
  //------------------------------------
  // 更新（新着グリッドは最大 27 件・サムネは即時 url 指定。足りなければ API を連続取得）
  //------------------------------------
  var update = function(page, reset) {

    var mobile = ($("menu-drawer").css("display") == "none" ? false : true);

    mobile = false;//仕組みを変えたので常にfalse
    
    //タグ
    var items = [];
      $(".selectTag input[type=checkbox]:checked").each(function(){
        items.push($(this).val());
      });
    
    var pstr = items.join(",");
  
    if (typeof page == "undefined") {
      page = 1;
    }
  
    if (typeof reset == "undefined") {
      reset = false;
    }
  
    var section_id = my_section_id;
  
    var search_text = $("#searchText").val().replace(/^(\s+)|(\s+)$/g, "");
    var api = Kanaco.api_base+"/Production_Case?page=" + page;
  
    api += "&tag=" + encodeURIComponent(pstr);
    api += "&search_text=" + encodeURIComponent(search_text);

    /* lang パラメーターを付けると API が全件同一の dpdc_id を返すため、
       Kanaco.api() ではなく $.ajax() を直接使用する */
    $.ajax({
      type: "GET",
      url: api,
      data: {},
      dataType: "json"
    }).done(function(res) {
      if (reset) {
        initArea();
        _no = 0;
        galleryLoadedCount = 0;
      }

      var hitCap = false;
      var nophoto = "https://cdn.shopify.com/s/files/1/0757/8094/8258/files/nophoto.jpg";

      if (res.data && res.data.items) {
        var arr = res.data.items;
        for (var ix = 0; ix < arr.length; ix++) {
          if (galleryLoadedCount >= GALLERY_MAX_ITEMS) {
            hitCap = true;
            break;
          }
          var item = arr[ix];
          _no++;

          var thumbRaw = item.image_thumb_url || nophoto;
          var thumbEsc = String(thumbRaw).replace(/\\/g, "\\\\").replace(/'/g, "\\'");

          /* 詳細ページへ直接遷移（/pages/gallery?id=XXXX）。
             gallery 内に詳細セクション（production-case-detail）を同居させ、
             ?id= 有無で一覧／詳細を出し分ける構成。 */
          var detailHref = detailPageBaseUrl + "?id=" + encodeURIComponent(item.dpdc_id);
          var _currentTagItems = [];
          $('.selectTag input[type=checkbox]:checked').each(function() {
            _currentTagItems.push($(this).val());
          });
          var _taggedDetailHref = detailHref + (_currentTagItems.length ? '&tag=' + encodeURIComponent(_currentTagItems.join(',')) : '');

          var isLast = (ix === arr.length - 1) && !hitCap && galleryLoadedCount < GALLERY_MAX_ITEMS;
          var item_html = "";
          item_html += '<li class="case production-case-grid__item" no="'+_no+'" data-id="'+item.dpdc_id+'" data-page="'+page+'">';
          item_html += '  <a href="' + _taggedDetailHref + '" class="production-case-grid__link js-fadeUp is-inview lazyload-trigger" data-page="'+page+'" data-no="'+_no+'" data-last="' + (isLast ? '1' : '0') + '">';
          item_html += '    <span class="production-case-grid__media image" style="background-image:url(\'' + thumbEsc + '\')"></span>';
          item_html += '  </a>';
          item_html += '</li>';

          $("#shopify-section-" + section_id + " .caseArea ul").append(item_html);
          galleryLoadedCount++;
        }
      }

      var fetchMore =
        !hitCap &&
        galleryLoadedCount < GALLERY_MAX_ITEMS &&
        res.data &&
        res.data.items &&
        res.data.items.length > 0;






      if (fetchMore) {
        // 次ページはIntersectionObserverで最後のアイテムが見えたときに取得
        setLazyload();
        $(document).trigger("updateGallery");
        return;
      }

      $(document).trigger("updateGallery");









    });
  }

  //if (!stag) {
  if (!target_id && !stag) {
    update(1, true);
  }

  var addSelectTag = function(elm){
    var checked_tag = {};
    var tag_id = $(elm).data("id");
    checked_tag.id = tag_id;
    checked_tag.group = $(elm).data("group");
    checked_tag.tag = $(elm).data("tag");
    checked_tags.push(checked_tag);
  }
  var removeSelectTag = function(elm){
    var tag_id = $(elm).data("id");
    for (var i=0; i<checked_tags.length; i++) {
      if (checked_tags[i].id == tag_id) {
        checked_tags.splice(i, 1);
      }
    }
  }
  
  //PC用タグ
  $(document).on("change", ".selectTag input[type=checkbox]", function(){
    if ($(this).prop("checked")) {
      addSelectTag(this);
    } else {
      removeSelectTag(this);
    }
    setSelectTagArea();
    resetListHref();
    update(1, true);
  });

  //スマホ用タグ
  $(document).on("click", ".mobile-search-trigger", function(){
    resetListHref();
    update(1, true);
  });

  //-----------------------------------------------------------
  //詳細表示
  //-----------------------------------------------------------
  var pushState_flg = false;
  // 詳細ページ（?id=あり）ではpushStateをスキップ
  var _hasIdOnLoad = !!(new URLSearchParams(location.search).get('id'));
  if (!_hasIdOnLoad) {
    history.pushState('showcase', null, list_href);
  }
  $(window).off('popstate').on('popstate', function(e) {
    if(e.originalEvent.state == 'showcase') { 
      $(".extMdlShowCaseDetail a.close").trigger("click");
      pushState_flg = false;
    }
  });
  /** 詳細モーダル：前後ナビ対象のスライダー（人気 / Before&After）。グリッドから開いたときは false */
  var slider_track = false;
  $(document).on("click", ".caseItem,.relateItem", function(){
    if ($(this).hasClass("caseItem")) {
      var $host = $(this).closest("#casePopularAreaWrapper, #caseBeforeAfterAreaWrapper");
      slider_track = $host.length ? ("#" + $host.attr("id")) : false;
    }
    var item_id = $(this).data("id");
    
    if (!pushState_flg) {
      //history.pushState('showcase', null, location.href);
      //history.pushState('showcasedetail', null, location.href);
      //alert("履歴に追加");
      history.pushState('showcasedetail', null, '/pages/gallery?id=' + item_id);
      pushState_flg = true;
    } else {
      //alert("履歴に追加しない2");
      history.replaceState('showcasedetail', null, '/pages/gallery?id=' + item_id);
    }
    
    if (typeof window.body_overflow == "undefined") {
      window.body_overflow = $("body").css("overflow");
      if (typeof window.body_overflow == "undefined") {
        window.body_overflow = null;
      }
    }

    $("body").css("overflow", "hidden");

    $(".extMdlShowCaseDetail").find(".name").html($(this).data("title"));
    $(".extMdlShowCaseDetail").find(".tag").html($(this).data("tags"));
    $(".extMdlShowCaseDetail").find(".text1").html($(this).data("description").replace(/\n/, '<br>'));
    $(".extMdlShowCaseDetail").find(".text2").html($(this).data("way").replace(/\n/, '<br>'));
    $(".extMdlShowCaseDetail").find(".image").css("background-image", "url(" + $(this).data("image") + ")");
    $(".extMdlShowCaseDetail .relate .inner .caseList ul").empty();
    if (!header_footer_disable && $(this).data("link")) {
      //$(".extMdlShowCaseDetail .link").attr("href", $(this).data("link")).show();
      $(".extMdlShowCaseDetail .link").attr("href", Shopify.rewriteLinkStr($(this).data("link"))).show();
    } else {
      $(".extMdlShowCaseDetail .link").hide();
    }

    $(".extMdlShowCaseDetail").show();

    //関連商品
    var api = Kanaco.api_base+"/Production_Case?mode=relate";
    var tagids = $(this).data("tagids");
    api += "&target_tag=" + tagids;
    api += "&id=" + item_id;

    $.ajax({
      type: "GET",
      url: api,
      data: {},
      dataType: "json"
    }).done(function(res) {

      if (res.data && res.data.items) {
        for (var i in res.data.items){
          var item = res.data.items[i];
          var item_html = "";
          item_html += '<li>';
          item_html += '  <a href="Javascript:void(0);" class="nonmover relateItem" style="background-image: url('+item.image_thumb_url+');" data-id="'+item.dpdc_id+'" data-link="'+item.dpdc_url+'" data-title="'+item.dpdc_name+'" data-description="'+item.dpdc_text1+'" data-way="'+item.dpdc_text2+'" data-tags="' + item.tag_name + '" data-tagids="' + item.dpdc_tag + '" data-image="'+item.image_url+'" data-image-thumb="'+item.image_thumb_url+'" data-open="'+item.open+'">&nbsp;</a>';
          item_html += '</li>';
          $(".extMdlShowCaseDetail .relate .inner .caseList ul").append(item_html);
        }
      }
    });

    //前後を調べる
    $(".extMdlShowCaseDetail .prev").off("click").css("opacity", 0.3);
    $(".extMdlShowCaseDetail .next").off("click").css("opacity", 0.3);
    var $myItem = null;
    var in_slider = slider_track === "#casePopularAreaWrapper" || slider_track === "#caseBeforeAfterAreaWrapper";
    if (in_slider) {
      $myItem = $(slider_track + " .production-case-carousel .case[data-id=" + item_id + "]").parents(".slick-slide:first");
    } else {
      $myItem = $(".caseArea ul li[data-id=" + item_id + "]");
    }
    if ($myItem.length && ((!in_slider && $myItem.prev(".case").length) || (in_slider && $myItem.prev(".slick-slide").length))) {
      $(".extMdlShowCaseDetail .prev").css("opacity", 1);
      $(".extMdlShowCaseDetail .prev").on("click", function() {
        if (in_slider) {
          $(slider_track + " .production-case-carousel .case[data-id=" + $myItem.prev(".slick-slide").find(".case").data("id") + "] .caseItem").trigger("click");
        } else {
          $(".caseArea ul li[data-id=" + $myItem.prev(".case").data("id") + "] .caseItem").trigger("click");
        }
      });
    }
    if ($myItem.length && ((!in_slider && $myItem.next(".case").length) || (in_slider && $myItem.next(".slick-slide").length))) {
      $(".extMdlShowCaseDetail .next").css("opacity", 1);
      $(".extMdlShowCaseDetail .next").on("click", function() {
        if (in_slider) {
          $(slider_track + " .production-case-carousel .case[data-id=" + $myItem.next(".slick-slide").find(".case").data("id") + "] .caseItem").trigger("click");
        } else {
          $(".caseArea ul li[data-id=" + $myItem.next(".case").data("id") + "] .caseItem").trigger("click");
        }
      });
    } else {
      //続きがある場合
      if (!in_slider) {
        if ($(".caseArea ul li .caseItem[data-last=1]")) {
          //スクロールして次のデータを取得
          var $target = $myItem;
          if (!$myItem.length) {
            $target = $(".caseArea ul li:last");
          }
          $(document).scrollTop($target.offset().top);
          $(document).off("updateGallery.detail").on("updateGallery.detail", function(){
            if ($myItem.length) {
              if ($myItem.next(".case").length) {
                $(".extMdlShowCaseDetail .next").css("opacity", 1);
                $(".extMdlShowCaseDetail .next").off("click").on("click", function() {
                  $(".caseArea ul li[data-id=" + $myItem.next(".case").data("id") + "] .caseItem").trigger("click");
                });
              }
            } else {
              $myItem = $(".caseArea ul li[data-id=" + item_id + "]");
              if ($myItem.length && $myItem.prev(".case").length) {
                $(".extMdlShowCaseDetail .prev").css("opacity", 1);
                $(".extMdlShowCaseDetail .prev").off("click").on("click", function() {
                  $(".caseArea ul li[data-id=" + $myItem.prev(".case").data("id") + "] .caseItem").trigger("click");
                });
              }
              if ($myItem.next(".case").length) {
                $(".extMdlShowCaseDetail .next").css("opacity", 1);
                $(".extMdlShowCaseDetail .next").off("click").on("click", function() {
                  $(".caseArea ul li[data-id=" + $myItem.next(".case").data("id") + "] .caseItem").trigger("click");
                });
              }
            }
          });
        }
      }
    }
   
  });

  $(".extMdlShowCaseDetail a.close").on("click", function(){
    $(".extMdlShowCaseDetail").hide();
    $(document).off("updateGallery.detail");
    $(".extMdlShowCaseDetail .prev").off("click");
    $(".extMdlShowCaseDetail .next").off("click");

    if (window.body_overflow) {
      $("body").css("overflow", window.body_overflow);
    } else {
      $("body").css("overflow", "unset");
    }
    
    if (list_href != location.href) {
      //alert("履歴に追加しないで戻す");
      history.replaceState('showcase', null, list_href);
    }
    slider_track = false;
  });

  $(".search__button").on("click", function() {
    resetListHref();
    update(1, true);
  });

  //エンター制御
  $("#searchText").on('keypress', function(ev) {
    if ((ev.which && ev.which === 13) || (ev.keyCode && ev.keyCode === 13)) {
      //var search_text = $("#searchText").val().replace(/^(\s+)|(\s+)$/g, "");
      //if (search_text != "") {
          resetListHref();
          update(1, true);
      //}
    }
    return true;
  });
    
  setLazyload = function() {
    // 次ページトリガー：最後のアイテムが画面に入ったら次ページを取得
    var triggers = [].slice.call(document.querySelectorAll("a.lazyload-trigger[data-last='1']"));
    if ("IntersectionObserver" in window && triggers.length) {
      var triggerObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var page = parseInt(el.getAttribute("data-page"), 10) || 1;
          el.setAttribute("data-last", "0");
          el.classList.remove("lazyload-trigger");
          observer.unobserve(el);
          update(page + 1, false);
        });
      }, { rootMargin: "400px" });
      triggers.forEach(function(t) { triggerObserver.observe(t); });
    }

    let lazyImages = [].slice.call(document.querySelectorAll("a.lazyload"));


    // IntersectionObserver に対応しているブラウザのみ、処理を実行します
    if ("IntersectionObserver" in window) {
      // コールバック関数を登録して、IntersectionObserver のオブジェクトを生成します
      let lazyImageObserver = new IntersectionObserver(function(entries, observer) {

        // 対象となる画像要素毎に処理を行います
        entries.forEach(function(entry) {
          // この要素が画面に入ってきた場合
          if (entry.isIntersecting) {

            let lazyImage = entry.target;
            let $lazyImage = $(lazyImage);

            //if (!$lazyImage.hasClass("is-inview") && $lazyImage.data("image")) {
              //  $("<img></img>").attr("src", $lazyImage.data("image")).on("load", function(){
              //		$lazyImage.find(".image").css("background-image", "url(" + $lazyImage.data("image") + ")");
            if (!$lazyImage.hasClass("is-inview") && $lazyImage.data("image-thumb")) {
              $("<img></img>").attr("src", $lazyImage.data("image-thumb")).on("load", function(){
                $lazyImage.find(".image").css("background-image", "url(" + $lazyImage.data("image-thumb") + ")");
                $lazyImage.addClass("is-inview");
              });
              
              //ページング実行
              var last = $lazyImage.data("last");
              var page = $lazyImage.data("page");
              if (last && page && !target_id) {
                var next_page = page + 1;
                $lazyImage.data("last", 0);
                update(next_page);
              }

              //$lazyImage.data("image", "");
              //$lazyImage.data("image-thumb", "");
            }

            // "lazy" というCSSクラスを削除します
            lazyImage.classList.remove("lazyload");

            // この画像要素を観察対象から外します
            lazyImageObserver.unobserve(lazyImage);
          } else {

          }
        });
      });
      lazyImages.forEach(function(lazyImage) {
        // 観察を開始します
        lazyImageObserver.observe(lazyImage);
      });
    } else {
      // ここには、IntersectionObserver に対応していないブラウザ用の処理を
      // 記述しますが、Polyfill を使えばここの処理は必要ないでしょう
    }
  }
  setLazyload();

  var setLayout = function() {
	//スマホ対応
    //if ($(window).width() <= 550) {
    if ($(window).width() <= 990) {
      if (!$(".extMdlShowCaseDetail").hasClass("splayout")) {
        $(".extMdlShowCaseDetail").addClass("splayout");
        $section.addClass("splayout");
      }
    } else {
      if ($(".extMdlShowCaseDetail").hasClass("splayout")) {
        $(".extMdlShowCaseDetail").removeClass("splayout");
        $section.removeClass("splayout");
      }
    }
  }
  $(window).on("resize", function(){
    setLayout();
  });
  setLayout();

/*****
  //スマホのタググループ開閉
  $(document).on("click", ".tagGroupName", function(){
    $area = $(this).parents(".tagGroup:first").find(".tagList:first");
    $area.slideToggle(600);
    $(this).find('.icoOpen, .icoClose').toggle();
  });
*****/


  
  var setSelectTagArea = function() {
    var html = '';
    html += '<div class="active-facets active-facets-desktop">';
    for (var i=0; i<checked_tags.length; i++) {
      var checked_tag = checked_tags[i];
      html += '<facet-remove>';
      html += '  <a href="Javascript:void(0);" data-id="' + checked_tag.id + '" class="active-facets__button active-facets__button--light" role="button">';
      html += '    <span class="active-facets__button-inner button button--tertiary">';
      html += checked_tag.group + ":" + checked_tag.tag;
      html += '      <svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">';
      html += '        <path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>';
      html += '        <path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>';
      html += '      </svg>';
      html += '      <span class="visually-hidden">絞り込みを削除する</span>';
      html += '    </span>';
      html += '   </a>';
      html += '</facet-remove>';
    }
    //if (checked_tags.length >= 2) {//他の箇所に合わせる
      html += '<facet-remove class="active-facets__button-wrapper">';
      html += '  <a href="Javascript:void(0);" data-id="0" class="active-facets__button-remove underlined-link" role="button">';
      html += '    <span>すべてを削除する</span>';
      html += '  </a>';
      html += '</facet-remove>';
    //}
    html += '</div>';
    $("#selectTagArea").html(html);
  }
  $(document).on("click", "facet-remove a", function(){
    var tag_id = $(this).data("id");
    if (tag_id != 0) {
      $(".selectTag input[type=checkbox][data-id=" + tag_id + "]").prop("checked", false);
      $(".selectTag input[type=checkbox][data-id=" + tag_id + "]").trigger("change");
    } else {
      var _id = checked_tags[0].id;
      checked_tags = [];
      $(".selectTag input[type=checkbox]").prop("checked", false);
      $(".selectTag input[type=checkbox][data-id=" + _id + "]").trigger("change");
      
    }
  });
  
  var tagGroupItemAreaAllHide = function() {
    $(".tag-group-dropdowns .tag-group-item-area").removeClass("open");
    $(".tag-group-name").removeClass("open");
    $(".state").removeClass("open");
  }




  $(document).on("click", ".tag-group-item-area", function(e) {
    e.stopPropagation();
  });






  $(document).on("click", ".tag-group-area", function(e) {
    e.stopPropagation();
    var gi = $(this).data("group-index");
    var $tagname = $(this).find(".tag-group-name");
    var $state = $(this).find(".state");
    // ドロップダウンはwrapper外の.tag-group-dropdownsから取得
    var $itemarea = $(".tag-group-dropdowns .tag-group-item-area[data-group-index='" + gi + "']");
    if ($state.hasClass("open")) {
      tagGroupItemAreaAllHide();
    } else {
      tagGroupItemAreaAllHide();
      $state.addClass("open");
      $tagname.addClass("open");
      $itemarea.addClass("open");


      // ドロップダウンをクリックした要素の直下に位置合わせ
      var rect = this.getBoundingClientRect();
      var isSp = window.innerWidth < 990;
      if (isSp) {
        // SP: position:fixedでビューポート座標を使用（scrollYを足さない）
        $itemarea.css('position', 'fixed');
        var dropLeft = rect.left;
        var dropTop = rect.bottom;
        var dropWidth = $itemarea.outerWidth() || 300;
        if (dropLeft + dropWidth > window.innerWidth - 10) {
          dropLeft = window.innerWidth - dropWidth - 10;
        }
        $itemarea.css({
          top: dropTop + 'px',
          left: Math.max(10, dropLeft) + 'px'
        });
      } else {
        // PC: position:absoluteでドキュメント座標を使用
        $itemarea.css('position', '');
        var dropLeft = rect.left + window.scrollX;
        var dropTop = rect.bottom + window.scrollY;
        var dropWidth = $itemarea.outerWidth() || 300;
        if (dropLeft + dropWidth > window.innerWidth - 10) {
          dropLeft = window.innerWidth - dropWidth - 10;
        }
        $itemarea.css({
          top: dropTop + 'px',
          left: Math.max(10, dropLeft) + 'px'
        });
      }








    }
  });









  $(document).on("click", function(){
    tagGroupItemAreaAllHide();
  });

  /** designate designer-list と同じ設定。SP は 2 枚表示（slidesToShow: 2） */
  var slickSettingsBase = function() {
    return {
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipe: false,
      speed: 800,
      autoplay: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 2,
            swipe: false
          }
        },
        {
          breakpoint: slickSpBreakpoint,
          settings: {
            slidesToShow: 2,
            centerMode: false,
            swipe: true
          }
        }
      ]
    };
  };

  var setUpProductionCaseSliders = function() {
    $("#casePopularAreaWrapper .production-case-carousel, #caseBeforeAfterAreaWrapper .production-case-carousel").each(function() {
      var $inner = $(this);
      if ($inner.hasClass("slick-initialized")) {
        $inner.slick("unslick");
      }
      if (!$inner.children().length) {
        return;
      }
      function forceSlickArrowsVisible() {
        $inner.find(".slick-prev, .slick-next").each(function() {
          this.style.setProperty("position", "absolute", "important");
          this.style.setProperty("display", "flex", "important");
          this.style.setProperty("visibility", "visible", "important");
          this.style.setProperty("opacity", "1", "important");
          this.style.setProperty("z-index", "12", "important");
        });
      }
      $inner.off("init.productionCaseSlickArrows reInit.productionCaseSlickArrows breakpoint.productionCaseSlickArrows setPosition.productionCaseSlickArrows");
      $inner.on("init.productionCaseSlickArrows reInit.productionCaseSlickArrows breakpoint.productionCaseSlickArrows setPosition.productionCaseSlickArrows", forceSlickArrowsVisible);
      $inner.slick(slickSettingsBase());
      forceSlickArrowsVisible();
      window.setTimeout(forceSlickArrowsVisible, 0);
    });
  }
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-faq-pickup"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
  $('.tfaq__more-link').removeAttr('target');

  $(document).on('click', '.tfaq__question', function() {
    var $btn = $(this);
    var $item = $btn.closest('.tfaq__item');
    var $answer = $item.find('.tfaq__answer');
    var isOpen = $item.hasClass('is-open');

    if (isOpen) {
      $answer.slideUp(400);
      $item.removeClass('is-open');
      $btn.attr('aria-expanded', 'false');
      $answer.attr('aria-hidden', 'true');
      $btn.find('.tfaq__icon').text('+');
    } else {
      $answer.slideDown(400);
      $item.addClass('is-open');
      $btn.attr('aria-expanded', 'true');
      $answer.attr('aria-hidden', 'false');
      $btn.find('.tfaq__icon').text('-');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
